// extracted by mini-css-extract-plugin
export default {"card":"card_card__t4EZ3"};